import { Component, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { HubOverlayComponent } from '@crewdle/home-hub/angular';
import { WhiteLabelService } from '@crewdle/white-label/angular';
import { DataStoreService } from 'src/app/services/data-store/data-store.service';
import { HomeHubOverlayService } from './home-hub-overlay.service';

/**
 * Adapts Forge (dev-console) services to the packaged `crwd-home-hub-overlay`.
 * z-index 80 keeps it above the shell but below toasts (z-100) / dialogs
 * (z-200). Overlay chrome + animation live in `@crewdle/home-hub`.
 */
@Component({
  selector: 'app-home-hub-overlay',
  standalone: true,
  imports: [HubOverlayComponent],
  template: `
    <crwd-home-hub-overlay
      [open]="overlay.isOpen()"
      [zIndex]="80"
      [uid]="uid"
      [orgId]="orgId"
      [locale]="locale"
      [platformName]="platformName"
      [domainMap]="domainMap"
      (closed)="overlay.close()"
    />
  `,
})
export class HomeHubOverlayComponent {
  readonly overlay = inject(HomeHubOverlayService);
  private readonly dataStore = inject(DataStoreService);
  private readonly whiteLabel = inject(WhiteLabelService);
  private readonly transloco = inject(TranslocoService);

  get uid(): string | null {
    return this.dataStore.getProperty('authUser')?.uid ?? null;
  }

  get orgId(): string | null {
    return this.dataStore.getProperty('currentAccount')?.organizationId ?? null;
  }

  get locale(): string {
    return this.transloco.getActiveLang();
  }

  get platformName(): string | null {
    return this.whiteLabel.brand()?.platformName ?? null;
  }

  get domainMap(): Record<string, string> | null {
    return this.whiteLabel.domainMap();
  }
}
